<template>
    <div class="wrap">
        <iframe :src="src" frameborder="0" id="iframe"></iframe>
    </div>
</template>

<script>
import Messager from '@/utils/messenger_ext';
export default {
    data() {
        return {
            src:'',
        };
    },
    watch:{
        src(newVal, oldValw){
            console.log(newVal)
        }
    },

    components: {},

    computed: {
        access_token(){
            return this.$store.state.userInfo.me.accessToken
        },
    },

    created() {
        if(this.$route.query && this.$route.query.url){
            if (decodeURIComponent(this.$route.query.url).indexOf("?") === -1) {
                this.src=decodeURIComponent(this.$route.query.url)+`?access_token=${this.access_token}`
            }else{
                this.src=decodeURIComponent(this.$route.query.url)+`&access_token=${this.access_token}`
            }
        }else{
            this.$router.push({path:'/mine/MyInfo'})
        }
    },

    mounted() {
        var M = new Messager('parent', 'realName');
        M.addTarget(document.getElementById('iframe').contentWindow, 'childWindow');
        //跟账户中心H5通信获取其生成的支付链接,同时也通知其页面需要用到iframe通信。
        M.response('goPay', (data,done) => {
            if (data.success){
                let url=process.env.VUE_APP_ACCOUNTUI+data.pay_url;
                window.location.href = url;
            }
            done({effect:'YES'})
        })
        //让账户中心H5的实名认证页面忽略iframe通信逻辑，执行自己的业务逻辑。
        M.response('realNameEffect', (data,done) => {
            done({effect:'NO'})
        })
        //子页面（账户中心H5）退出操作调用
        M.response('quit', (data, done) => {
            this.$router.replace({
                path: '/mine/MyInfo',
            })
        });
        //因为人脸识别不支持在iframe中使用，这里要跟账户中心H5通信获取其生成的人脸识别链接，直接跳转，接下来交给账户中心H5。
        M.response('iprGoFace', (data,done) => {
            if (data.success){
                window.location.href = data.face_url;
            }
        })
    },

    methods: {
        
    },
};
</script>
<style lang='less' scoped>
.wrap{
    display: flex;
    flex: 1;
    background:#fff;
    box-sizing: border-box;
    iframe{
        flex:1
    }
}
</style>